/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  push_group,
  get_folder_detail,
  delete_group,
} from "../../App/actions/folderProjectAction";
import {
  set_value_user,
  resetSearchUser,
  searchCollaborator,
} from "../../App/actions/authActions";
import {
  searchUser,
  deleteMember,
  editMember,
  addMember,
} from "../../App/actions/groupActions";
import { set_value_project } from "../../App/actions/projectActions";
import { block_license_with_handler, is_pass_license_sharing } from "../../App/actions/filter_license";

/*PICTURE*/
import icon_delete_2 from "../../Assets/svg/icon_delete_2.svg";
import checklist from "../../Assets/svg/checklist.svg";
import icon_search from "../../Assets/svg/icon_search.svg";
import pic_static from "../../Assets/svg/profile_pic_comment.svg";

/*FUNCTION*/
import format_date_formal from "../../App/validation/format_date_formal";
import uuid from "../../App/validation/uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class FOLDER_COLLAB extends Component {
  state = {
    search_user: "",
    member: {},
    modal_add_group: false,
    modal_warning: false,
    modal_delete_group: false,
    modal_delete_member: false,
  };

  componentDidMount() {
    const folder_id = this.props.project.folder_id_selected_collab;
    const query = {
      folder_id,
    };
    this.props.get_folder_detail(query);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.project?.folder_detail?._id !==
      prevProps.project?.folder_detail?._id
    ) {
      const { folder_detail } = this.props.project;
      const groups_folder = folder_detail?.groups || [];
      if (groups_folder.length > 0) {
        this.props.set_value_user("group", groups_folder[0]);
      }
    }
  }

  componentWillUnmount() {
    this.props.set_value_user("group", {});
    this.props.set_value_project({
      key: "folder_detail",
      value: {},
    });
  }

  setGroup = (group) => {
    this.props.set_value_user("group", group);
  };

  toggle_add_group = () => {
    if (this.props.is_pass_license_sharing()) {
      this.setState({
        modal_add_group: !this.state.modal_add_group,
      });
    } else {
      this.props.block_license_with_handler();
      this.setState({ modal_add_group: false });
    }
  };

  toggle_payment_universal = () => {
    const { modal_payment_universal } = this.props.auth;
    this.props.set_value_user(
      "modal_payment_universal",
      !modal_payment_universal
    );
  };

  toggle_delete_group = (group) => {
    this.setState(
      { modal_delete_group: !this.state.modal_delete_group },
      () => {
        if (!!group?._id) {
          this.props.set_value_user("group", group);
        }
      }
    );
  };

  toggle_warning = () => {
    this.setState({ modal_warning: !this.state.modal_warning });
  };

  on_push_group = (group_id) => {
    this.setState({ modal_add_group: false });
    const folder_id = this.props.project.folder_id_selected_collab;
    const body = {
      group_id,
      folder_id,
    };
    this.props.push_group(body);
  };

  on_delete_group = () => {
    this.setState({ modal_delete_group: false });
    const { group } = this.props.auth;
    const folder_id = this.props.project.folder_id_selected_collab;
    const body = {
      group_id: group._id,
      folder_id,
    };
    this.props.delete_group(body);
    this.props.set_value_user("group", {});
  };

  //search user
  on_change_search_user(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    clearTimeout(this.timer);
    this.setState({
      [name]: value,
    });
    this.timer = setTimeout(this.trigger_change.bind(this), WAIT_INTERVAL);
  }

  on_key_down(e) {
    if (e.keyCode === ENTER_KEY) {
      this.trigger_change.bind(this);
    }
  }

  trigger_change() {
    const { search_user } = this.state;
    this.props.searchCollaborator(search_user);
  }

  on_reset_search = () => {
    this.setState({ search_user: "" }, () => {
      this.props.resetSearchUser();
    });
  };

  on_edit_member = (e) => {
    e.preventDefault();
    const status = e.target.value;
    const member_id = e.target.name;
    const member_user_id = e.target.id;
    const folder_id = this.props.project.folder_id_selected_collab;
    const { group } = this.props.auth;
    const body = {
      group_id: group._id,
      member_id,
      member_user_id,
      status,
      folder_id,
    };
    this.props.editMember(body);
  };

  on_push_member = (member_id) => {
    if (this.props.is_pass_license_sharing()) {
      this.setState({ member_id }, () => {
        const { member_id } = this.state;
        const { group } = this.props.auth;
        const body = {
          group_id: group._id,
          member_id: member_id,
        };
        this.props.addMember(body);
      });
    } else {
      this.props.block_license_with_handler();
    }
  };

  toggle_delete_member = (member) => {
    this.setState({
      modal_delete_member: !this.state.modal_delete_member,
    });
    if (member) {
      this.setState({ member });
    }
  };

  on_delete_member = () => {
    this.setState({ modal_delete_member: false });
    const { member } = this.state;
    const { group } = this.props.auth;
    const body = {
      group_id: group._id,
      member_id: member._id,
      member_name: member?.user?.full_name
        ? member?.user?.full_name
        : member?.user?.name,
    };
    this.props.deleteMember(body);
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      modal_add_group,
      modal_warning,
      modal_delete_group,
      search_user,
      modal_delete_member,
    } = this.state;

    //global props
    const { folder_detail } = this.props.project;
    const { user, user_list, group, groups } = this.props.auth;

    //content
    const name = folder_detail?.name || "";
    const groups_folder = folder_detail?.groups || [];
    // const folder_owner = folder_detail?.user || {};
    let groups_id_in_folder = [];
    if (groups_folder.length > 0) {
      groups_id_in_folder = groups_folder.map(({ _id }) => {
        return _id;
      });
    }

    let members_group_id = [];
    if (groups_folder.length > 0) {
      const members_group = group.members || [];
      members_group_id = members_group.map((member) => member?.user?._id);
    }

    let member_status_current = "viewer";
    let group_members = [];
    if (group?._id) {
      group_members = group.members;
      const array_member_filtered = group.members.filter(
        (member) => member?.user?._id === user?._id
      )[0];
      if (array_member_filtered?.status) {
        member_status_current = array_member_filtered?.status;
      } else {
        member_status_current = "viewer";
      }
    }

    const modal_warning_content = modal_warning && (
      <Modal
        modalSize="small"
        id="warning modal"
        isOpen={modal_warning}
        onClose={this.toggle_warning}
      >
        <div className="box-body" style={{ textAlign: "center" }}>
          <div className="text_bold">
            {
              dict[
              "You are not an admin in this group, only admins can add groups to the project."
              ][language]
            }
          </div>
        </div>
      </Modal>
    );

    const modal_delete_group_content = modal_delete_group && (
      <Modal
        modalSize="small"
        id="deleteModal"
        isOpen={modal_delete_group}
        onClose={this.toggle_delete_group}
      >
        <div className="box-body">
          <div className="text_medium">
            {dict["Are you sure to delete"][language]}{" "}
            <b className="text_bold">{group.name}</b> {dict["from"][language]}{" "}
            <b className="text_bold">{name}</b>?
          </div>
          <br />
          <div className="text_inferior">
            {
              dict[
              "This action will not delete the group, just remove the group association with this project, the members of this group will no longer have access to this project."
              ][language]
            }
          </div>
          <br />
          <div
            className="button background_black"
            id="deleteBright"
            style={{ marginTop: "1rem" }}
            onClick={this.on_delete_group}
          >
            {dict["Process deletion"][language]}
          </div>
        </div>
      </Modal>
    );

    const modal_delete_member_content = modal_delete_member && (
      <Modal
        modalSize="small"
        id="deleteModal"
        isOpen={modal_delete_member}
        onClose={this.toggle_delete_member}
      >
        <div className="box-body" style={{ textAlign: "center" }}>
          {dict["Are you sure to delete"][language]}
          <div className="welcome" style={{ textAlign: "center" }}>
            {this.state.member?.user?.full_name
              ? this.state.member?.user?.full_name
              : this.state.member?.user?.name}
          </div>
          <br />
          <div
            className="button background_black"
            id="deleteBright"
            style={{ marginTop: "1rem" }}
            onClick={this.on_delete_member}
            data-mapid="clickDelete"
          >
            {dict["Process deletion"][language]}
          </div>
        </div>
      </Modal>
    );

    const modal_add_group_content = modal_add_group && (
      <Modal
        modalSize="large"
        isOpen={modal_add_group}
        onClose={this.toggle_add_group}
      >
        <div
          className="box-body"
          style={{ textAlign: "center", minHeight: "80vh" }}
        >
          <div style={{ marginBottom: "30px" }}>
            {dict?.["Add Group to Folder"]?.[language]}
          </div>
          <div>
            {groups.map(({ name, _id, members, payment }, idx) => {
              let org_content = null;
              if (!!payment.multiple_month) {
                const { date_in } = payment;
                const multiple_month = payment.multiple_month
                  ? payment.multiple_month
                  : 1;
                //86400 unix = 1 day
                //1 month = 30.5 day
                const month_unix = 86400 * 30.5;
                const day_unix = 86400;
                const date_finish_unix =
                  parseInt((new Date(date_in).getTime() / 1000).toFixed(0)) +
                  month_unix * multiple_month;
                const date_now_unix = parseInt(
                  (new Date(Date.now()).getTime() / 1000).toFixed(0)
                );
                const delta_unix =
                  (date_finish_unix - date_now_unix) * multiple_month;
                const delta_day = parseInt(delta_unix / day_unix);
                const date_finish = new Date(date_finish_unix * 1000);
                if (delta_day > 0) {
                  if (delta_day > 30) {
                    org_content = (
                      <div className="button_small background_white">
                        <b>
                          {dict["Team license active until"][language]}{" "}
                          {format_date_formal(date_finish)}
                        </b>
                      </div>
                    );
                  } else {
                    org_content = (
                      <div className="button_small background_white">
                        <b>
                          {dict["Team license active for"][language]}{" "}
                          {delta_day} {dict["days"][language]}
                        </b>
                      </div>
                    );
                  }
                } else {
                  org_content = (
                    <div className="button_small background_white">
                      <b>{dict["Team license exp."][language]}</b>
                    </div>
                  );
                }
              }
              let memberStatus = "viewer";
              const array_member_filtered = members.filter(
                (member) => member?.user?._id === user?._id
              )[0];
              if (array_member_filtered) {
                memberStatus = array_member_filtered?.status;
              }
              let groupCard;
              if (groups_id_in_folder.includes(_id)) {
                groupCard = (
                  <div
                    className="container_small background_grey_light margin_right margin_bottom outline_black"
                    key={idx}
                  >
                    <div className="text_medium margin_bottom">
                      {name}{" "}
                      <img alt="checklist" src={checklist} width="11px" />
                    </div>
                    {org_content}
                  </div>
                );
              } else {
                if (memberStatus === "creator" || memberStatus === "admin") {
                  groupCard = (
                    <div
                      className="container_small background_black margin_right margin_bottom outline_black"
                      onClick={this.on_push_group.bind(this, _id)}
                      key={idx}
                    >
                      <div className="text_medium margin_bottom">{name}</div>
                      {org_content}
                    </div>
                  );
                } else {
                  groupCard = (
                    <div
                      className="container_small background_grey_light margin_right margin_bottom outline_black"
                      onClick={this.toggle_warning}
                      key={idx}
                    >
                      <div className="text_medium margin_bottom">{name}</div>
                      {org_content}
                    </div>
                  );
                }
              }
              return groupCard;
            })}
          </div>
        </div>
      </Modal>
    );

    return (
      <main className="max_height">
        {modal_add_group_content}
        {modal_warning_content}
        {modal_delete_group_content}
        {modal_delete_member_content}
        <section style={{ textAlign: "center" }}>
          <div className="carousell">
            {groups_folder.map((group_element, idx) => {
              const { name, _id, members } = group_element;
              let userCurrentStatus = "viewer";
              const array_member_filtered = members.filter(
                (member) => member?.user?._id === user?._id
              )[0];
              userCurrentStatus = array_member_filtered?.status;
              let button_delete;
              if (
                userCurrentStatus === "creator" ||
                userCurrentStatus === "admin"
              ) {
                button_delete = (
                  <div
                    onClick={this.toggle_delete_group.bind(this, group_element)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={icon_delete_2}
                      alt="delete group"
                      width="15px"
                      height="auto"
                    />
                  </div>
                );
              }
              const is_active = group?._id === _id;
              const container_class = `container_small cursor_pointer margin_right inline background_grey_light ${is_active ? "outline_black" : "outline_grey"
                }`;
              const item = (
                <div
                  className={container_class}
                  onClick={this.setGroup.bind(this, group_element)}
                  key={idx}
                >
                  <p
                    className="text_small"
                    style={{ overflow: "hidden", maxHeight: "30px" }}
                  >
                    {name}
                  </p>
                  {button_delete}
                </div>
              );
              return item;
            })}
            <div
              className="container_small background_grey_light outline_grey inside_center_big"
              onClick={this.toggle_add_group}
            >
              +
            </div>
          </div>
        </section>

        <section style={{ textAlign: "center" }}>
          {(member_status_current === "creator" ||
            member_status_current === "admin") &&
            group?._id && (
              <main
                className="input_rounded margin_top"
                style={{ width: "100%", boxSizing: "border-box" }}
              >
                <main className="icon-text">
                  <section>
                    <img
                      src={icon_search}
                      alt="search"
                      height="16px"
                      className="margin_right"
                    />
                  </section>
                  <section>
                    <input
                      className="form-rounded"
                      type="text"
                      placeholder={`${dict["Search user to add as member"][language]}...`}
                      autoComplete="off"
                      name="search_user"
                      value={search_user}
                      onChange={this.on_change_search_user.bind(this)}
                      onKeyDown={this.on_key_down.bind(this)}
                      data-mapid="inputUser"
                    />
                  </section>
                  <section>
                    <div
                      onClick={this.on_reset_search}
                      style={{ marginBottom: "5px", cursor: "pointer" }}
                    >
                      X
                    </div>
                  </section>
                </main>
                <main>
                  <main
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                    data-mapid="clickUser"
                  >
                    {user_list.map(
                      ({ _id, name, full_name, profile_picture }, idx) => {
                        const isMember = members_group_id.includes(_id);
                        const displayName =
                          full_name && full_name !== "" && full_name !== "-"
                            ? full_name
                            : name;
                        const profilePic =
                          profile_picture && profile_picture.url_compressed
                            ? profile_picture.url_compressed
                            : profile_picture &&
                              profile_picture.url &&
                              ![
                                "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png",
                                "-",
                                "default",
                              ].includes(profile_picture.url)
                              ? profile_picture.url
                              : pic_static;
                        return (
                          <main
                            key={idx}
                            className={`user-unit ${isMember ? "member" : "non-member"
                              }`}
                            onClick={
                              !isMember
                                ? this.on_push_member.bind(this, _id)
                                : undefined
                            }
                          >
                            <section
                              alt={_id}
                              className="user-photo"
                              style={{ backgroundImage: `url(${profilePic})` }}
                            />
                            <section className="user-name">
                              {displayName}
                            </section>
                            {isMember && (
                              <section
                                alt={_id}
                                className="badge-member"
                                style={{ backgroundImage: `url(${checklist})` }}
                              />
                            )}
                          </main>
                        );
                      }
                    )}
                  </main>
                </main>
              </main>
            )}
          <main style={{ marginTop: "20px" }}>
            <p>{dict["Members in this project group"][language]}:</p>
            <table>
              <tbody>
                {group_members.map((member, idx) => {
                  const user = member?.user;
                  const status = member?.status;
                  let _id = uuid();
                  let member_id = uuid();
                  let full_name, profile_picture, name;
                  if (user) {
                    member_id = member._id;
                    _id = user?._id;
                    full_name = user?.full_name;
                    profile_picture = user?.profile_picture;
                    name = user?.name;
                  } else {
                    full_name = "Deleted user";
                  }
                  let delete_button;
                  const statusArray = ["admin", "contributor", "viewer"];
                  let statusButton;

                  if (status === "creator") {
                    statusButton = <p>{member?.status}</p>;
                  } else if (
                    member_status_current === "creator" ||
                    (member_status_current === "admin" &&
                      member?.user?.name !== this.props.auth.user?.name)
                  ) {
                    statusButton = (
                      <select
                        id={_id}
                        name={member_id}
                        value={status}
                        onChange={this.on_edit_member}
                        data-mapid={`selectStatus-${idx}`}
                      >
                        {statusArray.map((status, idx) => {
                          return (
                            <option key={idx} value={status}>
                              {status}
                            </option>
                          );
                        })}
                      </select>
                    );
                  } else {
                    statusButton = <div>{status}</div>;
                  }
                  if (
                    (member_status_current === "creator" ||
                      member_status_current === "admin") &&
                    status !== "creator" &&
                    member?.user?.name !== this.props.auth.user?.name
                  ) {
                    delete_button = (
                      <div
                        onClick={this.toggle_delete_member.bind(this, member)}
                        className="button background_black"
                        id="red"
                        data-mapid="deleteUser"
                      >
                        {dict["Delete"][language]}
                      </div>
                    );
                  } else {
                    delete_button = null;
                  }
                  const picture_src =
                    profile_picture && profile_picture.url_compressed
                      ? profile_picture.url_compressed
                      : profile_picture &&
                        profile_picture.url &&
                        profile_picture.url !==
                        "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png" &&
                        profile_picture.url !== "-" &&
                        profile_picture.url !== "default"
                        ? profile_picture.url
                        : pic_static;
                  return (
                    user && (
                      <tr key={idx} data-mapid={`tableTr-${idx}`}>
                        <td
                          style={{
                            textAlign: "left",
                            marginBottom: "10px",
                            width: "40px",
                          }}
                        >
                          <div
                            alt={_id}
                            className="user-photo"
                            style={{ backgroundImage: `url(${picture_src})` }}
                            samesite="None"
                            secure="true"
                          />
                        </td>
                        <td
                          style={{
                            width: "250px",
                          }}
                        >
                          <div style={{ textAlign: "left" }}>
                            {full_name && full_name !== "" && full_name !== "-"
                              ? full_name
                              : name}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "150px",
                          }}
                        >
                          <div style={{ textAlign: "left" }}>
                            {member_status_current !== "creator" &&
                              member_status_current !== "admin" ? (
                              <p>{member?.status}</p>
                            ) : (
                              statusButton
                            )}
                          </div>
                        </td>
                        <td
                          style={{
                            width: "100px",
                          }}
                        >
                          {delete_button}
                        </td>
                      </tr>
                    )
                  );
                })}
              </tbody>
            </table>
          </main>
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  project: state.project,
  auth: state.auth,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  push_group,
  get_folder_detail,
  set_value_user,
  delete_group,
  searchUser,
  resetSearchUser,
  deleteMember,
  editMember,
  addMember,
  set_value_project,
  searchCollaborator,
  is_pass_license_sharing,
  block_license_with_handler
})(FOLDER_COLLAB);
